// @ts-nocheck
import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { FORM6_TRANSPORTED_WASTE } from '../../constants/lkCadastr/cadastrForm6';
import useCadastreTabs from '../../hooks/useCadastreTabs';
import { Form6TransportedWaste } from '../Modals/ModalCadastrForms/components/Form6/Form6TransportedWaste';
import NavTabs from '../Tabs';
import { useCadastreStore } from '../../store';

export default function CadastreForm6ActualVolume({
  actualVolume,
  actualVolumes,
  onChange,
  isDemo,
  changeItemFormByField,
  setCreateSubjectInfo,
  openDeleteModal,
  actualVolumeIndex,
  deleteForm6Entity,
  setTransportedWasteTab,
}) {
  const transportedWastes = actualVolume[FORM6_TRANSPORTED_WASTE];

  const { tabs, tab, setTab } = useCadastreTabs({ items: transportedWastes, tabName: 'Транспортируемый отход' });
  const { cadastreStore } = useCadastreStore();

  const changeItem = (field, value, transportedWasteIndex) => {
    onChange({
      field: `actualVolumes.${actualVolumeIndex}.${field}`,
      value,
      reportActualVolumeIndex: actualVolumeIndex,
      transportedWasteIndex,
    });
  };

  useEffect(() => {
    setTransportedWasteTab(tab);
  }, [tab]);

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <NavTabs getErrorTab={(tabId) => cadastreStore.errorForm6?.some((item) => item.includes(tabId))} tabsComponents={tabs} setTab={setTab} tab={tab} />
      <Form6TransportedWaste
        isDemo={isDemo}
        tab={tab}
        deleteForm6Entity={deleteForm6Entity}
        actualVolume={actualVolume}
        openDeleteModal={openDeleteModal}
        setCreateSubjectInfo={setCreateSubjectInfo}
        changeItemFormByField={(value, type) => changeItemFormByField({
          field: `form6.actualVolumes.${actualVolumeIndex}.${FORM6_TRANSPORTED_WASTE}`,
          value,
          type,
        })}
        onChange={changeItem}
        transportedWastes={transportedWastes}
      />
    </Box>
  );
}
